import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CORE_BASIC_SERVICE_URI } from 'library-@/config/apiConfig';
import type { ApiCopilotFeedback, ApiCopilotFeedbackRequest, ApiCopilotFeedbackResponse, ApiCopilotInit, ApiCopilotInitRequest, ApiCopilotInitResponse } from './core-basic-api-service.interface';

@injectable()
export class CoreBasicApiServiceImpl extends PsHttpService
    implements
        ApiCopilotFeedback,
        ApiCopilotInit {

    get options() {
        return {
            baseURL: CORE_BASIC_SERVICE_URI,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async copilotFeedback(data: ApiCopilotFeedbackRequest): Promise<ApiCopilotFeedbackResponse> {
        const res = await this.post<PatSnapSuccessResponseData<ApiCopilotFeedbackResponse>>({
            url: '/core-copilot-api/analytics/copilot/feedback',
            data,
            transformCode: true,
        });
        return res.data;
    }


    async copilotInit(data: ApiCopilotInitRequest): Promise<ApiCopilotInitResponse> {
        const res = await this.get<PatSnapSuccessResponseData<ApiCopilotInitResponse>>({
            url: '/core-copilot-api/analytics/copilot/init',
            data,
            transformCode: true,
        });
        return res.data;
    }
}
